// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3TJnz","col":"styles_col__YALwA"};